import { getNewArticles } from '@/mocks/articles';
import VideoCard from '@/components/feature/VideoCard';

export default function LatestUpdates() {
  const newArticles = getNewArticles().slice(0, 6);

  return (
    <section className="py-10 md:py-14">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-6">
          <div className="flex items-center gap-3">
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900">
              最新更新
            </h2>
            <span className="px-2.5 py-1 text-xs bg-accent-100 text-accent-700 rounded-full font-medium">
              今日
            </span>
          </div>
          <a href="/" className="text-sm text-primary-500 hover:text-primary-600 transition-colors flex items-center gap-1">
            更多内容 <i className="ri-arrow-right-line"></i>
          </a>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {newArticles.map((article) => (
            <VideoCard key={article.id} article={article} />
          ))}
        </div>
      </div>
    </section>
  );
}